import { render, staticRenderFns } from "./ticket-renewal.component.vue?vue&type=template&id=0d0bd14a"
import script from "./ticket-renewal.component.vue?vue&type=script&lang=js"
export * from "./ticket-renewal.component.vue?vue&type=script&lang=js"
import style0 from "./ticket-renewal.component.vue?vue&type=style&index=0&id=0d0bd14a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports